import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl
} from '@angular/forms';
import { combineLatest } from 'rxjs';
import { take } from 'rxjs/operators';

import { VALIDATORS } from 'app/constants';
import { AppArticle as Article } from 'graphql/models/extended';
import { Category } from 'graphql/models/generated';
import { CoreDataService } from 'shared/services/core-data.service';
import { PermissionsService } from 'shared/services/permissions.service';
import { StoreService } from 'shared/services/store.service';

@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss']
})
export class ArticleComponent implements OnInit {
  dropdownData = {
    categories: [] as Category[],
  };

  form!: UntypedFormGroup;

  formReady = false;

  isDealer!: boolean;

  get category(): UntypedFormControl {
    return this.form.controls.category as UntypedFormControl;
  }

  constructor(
    protected fb: UntypedFormBuilder,
    private storeService: StoreService,
    private coreDataService: CoreDataService,
    private permissionsService: PermissionsService
  ) { }

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    combineLatest([
      this.storeService.isCurrentAccountDealer()
    ])
    .pipe(take(1))
    .subscribe(([isDealer]: [boolean]) => {
      this.isDealer = isDealer;

      this.getCategories();
      this.setupForm();
    });
  }

  getCategories(): void {
    this.coreDataService.getArticleCategories()
      .subscribe((data: Category[]) => {
        this.dropdownData.categories = data;
      });
  }

  setupForm(): void {
    this.storeService.setFormReady(this.formReady);

    this.storeService.getCurrentArticle()
      .subscribe((data: Article) => {
        const article = data || {};
        let category = null;

        if (article.category?.displayName) {
          category = article.category.displayName;
        }

        this.form = this.fb.group({
          mnr: [article.mnr || ''],
          ean: [article.ean || ''],
          name: [article.name || '', [Validators.required, Validators.pattern(VALIDATORS.PATTERN.NO_BLANK_STRING)]],
          description: [article.description || ''],
          category: [category],
          originalCategory: [category],
          unit: [article.unit || ''],
          listPrice: [article.listPrice || '', [
            Validators.min(VALIDATORS.MIN.ARTICLE_LIST_PRICE), Validators.max(VALIDATORS.MAX.ARTICLE_LIST_PRICE)
          ]],
          purchasePrice: [article.purchasePrice || '', [
            Validators.min(VALIDATORS.MIN.ARTICLE_PURCHASE_PRICE), Validators.max(VALIDATORS.MAX.ARTICLE_PURCHASE_PRICE)
          ]],
          width: [article.width || ''],
          height: [article.height || ''],
          depth: [article.depth || ''],
          direction: [article.direction || ''],
        }, { updateOn: 'blur' });

        if (!this.permissionsService.canUpdateArticles()) {
          this.form.disable({ emitEvent: false });
        }

        this.formReady = true;
        this.storeService.setFormReady(this.formReady);
      });
  }
}
